export default {
  post: state => {
    return state.post
  }
}